import React, { useContext, useState } from 'react';
import {  Link } from 'react-router-dom';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import BackgroundLetterAvatars from '../BackgroundLetterAvatars';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import Logo from '../../../images/logo1.webp'
import ClientHeader from '../ClientHeader';
import CustomizedMenus from '../../CustomizedMenus';
import NavLinks from '../Navigation/NavLinks';
import { AuthContext } from '../../../shared/context/auth-context';


import './MainNavigation.css';
import './NavLinks.css';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(0),
  },
  //Display name position
  nameDisplay: {
    // display: "none",
    marginRight: theme.spacing(0),
    [theme.breakpoints.up("sm")]:{
      display: "block"
    }
  },
  mainNavigationTitle: {
    textDecorationLine: 'none'
  },
  logoPosition: {
    margin: 0,
    padding: 0,
    width: 100,
    height:50,
  },
  //TO MANAGE SIDEDRAWER
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  }
}));

//DEFINE SIDEDRAWER


const MainNavigation = props => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('768'));
  const isMatches = useMediaQuery(theme.breakpoints.up('768'));
  const auth = useContext(AuthContext);
  //STATE AND METHODS TO MANAGE SIDEDRAWER
  const [state, setState] = useState({
    left: false
  });

  let displayMenu;
  if (auth.isLoggedIn) {
    displayMenu = (<CustomizedMenus/>);
    if (!isMatches) {
       displayMenu = (<CustomizedMenus/>);
      //displayMenu = (<BackgroundLetterAvatars/>);
    }
  }

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
          <NavLinks/>
    </div>
  );

  return (
    <>
    <ClientHeader>
        {matches && <IconButton 
                      edge="start" 
                      onClick={toggleDrawer('left', true)} 
                      className={classes.menuButton} 
                      color="inherit" 
                      aria-label="menu">
                      <MenuIcon/>
                    </IconButton>}
                    <SwipeableDrawer
                      anchor='left'
                      open={state['left']}
                      onClose={toggleDrawer('left', false)}
                      onOpen={toggleDrawer('left', true)}
                      >
                      {list('left')}
                      </SwipeableDrawer>
        <Link to="/sommaire" className={classes.mainNavigationTitle}>
          <div className={classes.logoPosition}>
            <img src={Logo} height={60} width={100} alt="PraticoPret"/>
          </div>
        </Link>
        <Grid container alignItems="center">
          <Grid item>
            <nav className="main-navigation__header-nav">
              <NavLinks/>
            </nav>
          </Grid>
          <Grid item sm></Grid>
        </Grid>
        <Grid item className={classes.nameDisplay} >
            {displayMenu}
          </Grid>
    </ClientHeader>
    
    </>
  );
}

export default MainNavigation;
